var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTriangleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.793 4.425a.5.5 0 01-.38.825H.587a.5.5 0 01-.38-.825L3.62.443a.5.5 0 01.76 0l3.413 3.982z",
    fill: "#4C6AFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNy43OTI1MiA0LjQyNDZDOC4wNzA1MiA0Ljc0ODk0IDcuODQwMDcgNS4yNSA3LjQxMjg5IDUuMjVMMC41ODcxMTEgNS4yNUMwLjE1OTkzNCA1LjI1IC0wLjA3MDUyMDkgNC43NDg5NCAwLjIwNzQ4MiA0LjQyNDZMMy42MjAzNyAwLjQ0MjlDMy44MTk5MiAwLjIxMDA5NCA0LjE4MDA4IDAuMjEwMDk0IDQuMzc5NjMgMC40NDI5TDcuNzkyNTIgNC40MjQ2WiIgZmlsbD0iIzRDNkFGRiIvPgo8L3N2Zz4K";
export { SvgFilterTriangleUp as ReactComponent };